// This season's show. Change these when the new revue is announced.
// The dates, sponsors, menu and past shows come from Storyblok.
export const SHOW_TITLE = 'Wat ’n Spul'

// The logo and poster of the show, from public/socials (web versions in public/socials/web)
export const SHOW_LOGO = { src: '/socials/web/watn-spul-logo-1200.webp', width: 1200, height: 361 }

export const SHOW_POSTER = {
  // The campaign photo without logo (the logo goes next to the dates); landscape on larger screens, portrait on phones
  wide: { srcset: '/socials/web/watn-spul-liggend-foto-1600.webp 1600w, /socials/web/watn-spul-liggend-foto-2560.webp 2560w', width: 1600, height: 1067 },
  tall: { srcset: '/socials/web/watn-spul-staand-foto-800.webp 800w, /socials/web/watn-spul-staand-foto-1200.webp 1200w', width: 800, height: 1200 },
  alt: 'Drie spelers van Wat ’n Spul voor een boerderij: een man met een hark en een aktetas, een vrouw met een plumeau en een jonge vrouw in een zwarte jurk lachen in de camera.'
}

const PHOTO = 'https://a.storyblok.com/f/283398'

// Production photos that follow the cursor over the date rows
export const SHOW_PEEK_PHOTOS = [
  `${PHOTO}/1200x900/df2a37edba/_r6a3344.jpg`,
  `${PHOTO}/6336x9504/4f8b34d1de/hr2026-70.jpg`,
  `${PHOTO}/4672x7008/0f4ffcef69/hr2026-29.jpg`,
  `${PHOTO}/4160x6240/834f1f8f6b/hr2026-112.jpg`,
  `${PHOTO}/8168x5445/42cd218d17/hr2026-100.jpg`,
  `${PHOTO}/6336x9504/4ad2725afb/hr2026-78.jpg`
]

export const SHOW_REEL_PHOTOS = [
  { src: `${PHOTO}/6336x9504/4f8b34d1de/hr2026-70.jpg`, alt: 'Twee dansers in paarse glitterkostuums met de armen omhoog', caption: 'Dans met de live band' },
  { src: `${PHOTO}/4672x7008/0f4ffcef69/hr2026-29.jpg`, alt: 'Speler in een Hawaïhemd en een broek met rode bloemen', caption: 'Humor' },
  { src: `${PHOTO}/4160x6240/834f1f8f6b/hr2026-112.jpg`, alt: 'Zanger met microfoon voor de drummer', caption: 'Zang' },
  { src: `${PHOTO}/6336x9504/3920ce1fb8/hr2026-117.jpg`, alt: 'Twee spelers in witte gewaden met rode hoofddoeken', caption: 'Kostuums uit eigen atelier' },
  { src: `${PHOTO}/842x1200/362189e4f5/_za_4041.jpg`, alt: 'Danspaar in het rood op het podium', caption: 'Effe Wachten, 2025' },
  { src: `${PHOTO}/6336x9504/4ad2725afb/hr2026-78.jpg`, alt: 'Twee speelsters en een speler in een scène voor rode gordijnen', caption: 'Oost, West, Thuis…?, 2026' },
  { src: `${PHOTO}/6336x9504/2a9a4466f5/hr2026-62.jpg`, alt: 'Rita van Veen in de kleedkamer', caption: 'Achter de schermen' }
]
